/**
 * Intrastat: Schluessel fuer die Meldung an das Statistische Bundesamt.
 *
 * Gemeldet werden innergemeinschaftliche Warenbewegungen: Versendungen
 * (Verkauf in andere EU-Staaten) und Eingaenge (Einkauf aus anderen
 * EU-Staaten). Die Datei folgt der IDEV-Vorlage von Destatis: Semikolon,
 * eine Zeile je Rechnungsposition, Schluessel statt Klartext.
 */
/** EU-Mitgliedstaaten (ISO 3166-1 alpha-2), Stand 2026. */
export const EU_MEMBER_STATES = {
    AT: 'Österreich',
    BE: 'Belgien',
    BG: 'Bulgarien',
    CY: 'Zypern',
    CZ: 'Tschechien',
    DE: 'Deutschland',
    DK: 'Dänemark',
    EE: 'Estland',
    ES: 'Spanien',
    FI: 'Finnland',
    FR: 'Frankreich',
    GR: 'Griechenland',
    HR: 'Kroatien',
    HU: 'Ungarn',
    IE: 'Irland',
    IT: 'Italien',
    LT: 'Litauen',
    LU: 'Luxemburg',
    LV: 'Lettland',
    MT: 'Malta',
    NL: 'Niederlande',
    PL: 'Polen',
    PT: 'Portugal',
    RO: 'Rumänien',
    SE: 'Schweden',
    SI: 'Slowenien',
    SK: 'Slowakei',
};
export function isEuMemberState(country) {
    return Boolean(country) && Object.hasOwn(EU_MEMBER_STATES, country.toUpperCase());
}
/** Bundeslaender mit dem amtlichen Schluessel (Ursprungs- bzw. Bestimmungsbundesland). */
export const BUNDESLAENDER = [
    { code: '01', label: 'Schleswig-Holstein' },
    { code: '02', label: 'Hamburg' },
    { code: '03', label: 'Niedersachsen' },
    { code: '04', label: 'Bremen' },
    { code: '05', label: 'Nordrhein-Westfalen' },
    { code: '06', label: 'Hessen' },
    { code: '07', label: 'Rheinland-Pfalz' },
    { code: '08', label: 'Baden-Württemberg' },
    { code: '09', label: 'Bayern' },
    { code: '10', label: 'Saarland' },
    { code: '11', label: 'Berlin' },
    { code: '12', label: 'Brandenburg' },
    { code: '13', label: 'Mecklenburg-Vorpommern' },
    { code: '14', label: 'Sachsen' },
    { code: '15', label: 'Sachsen-Anhalt' },
    { code: '16', label: 'Thüringen' },
];
/** Verkehrszweig (Art der Befoerderung an der Grenze). */
export const INTRASTAT_TRANSPORT_MODES = [
    { code: '1', label: 'Seeverkehr' },
    { code: '2', label: 'Eisenbahnverkehr' },
    { code: '3', label: 'Straßenverkehr' },
    { code: '4', label: 'Luftverkehr' },
    { code: '5', label: 'Postsendungen' },
    { code: '7', label: 'Feste Transportinstallationen' },
    { code: '8', label: 'Binnenschifffahrt' },
    { code: '9', label: 'Eigener Antrieb' },
];
/** Art des Geschaefts, die im Handel ueblichen Schluessel. */
export const INTRASTAT_TRANSACTION_TYPES = [
    { code: '11', label: 'Endgültiger Kauf/Verkauf' },
    { code: '12', label: 'Ansichts- oder Probesendung, Kommission' },
    { code: '21', label: 'Rücksendung von Waren' },
    { code: '22', label: 'Ersatzlieferung für zurückgesandte Waren' },
    { code: '23', label: 'Ersatzlieferung ohne Rücksendung (Garantie)' },
];
export const INTRASTAT_DIRECTION_LABELS = {
    dispatch: 'Versendung',
    arrival: 'Eingang',
};
//# sourceMappingURL=intrastat.js.map